import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    body: 'Legally, you are required to keep your accounting documents (invoices, receipts) for 10 years but also to keep an accounting book (the accounting export can serve as an accounting book).',
    goToExplanation: 'Download my accounting export',
    next: 'I’ve downloaded it',
    title: 'Have you downloaded your accounting export?',
  },
  fr: {
    body: 'Légalement, vous êtes tenus de garder vos justificatifs comptables (factures, reçus) durant 10 ans mais aussi tenir un livre de recettes (l’export comptable peut faire office de livre de recettes).',
    goToExplanation: 'Récupérer mon export comptable',
    next: 'Je l’ai récupéré',
    title: 'Avez-vous récupéré votre export comptable ?',
  },
});

export default locales;
